import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { login } from '../../actions/Login/loginActions';

const LoginForm = ({ className }) => {
    const [isLoading, setLoading] = useState(false);
    const [hasError, setError] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const dispatch = useDispatch();

    const clickHandler = () => {
        setLoading(true);
        dispatch(
            login({
                username,
                password
            })
        )
            .then(() => {
                setError(false);
            })
            .catch(() => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className={className}>
            <h2>اطلاعات کاربری</h2>
            <Input
                type="text"
                placeholder="نام کاربری خود را وارد کنید"
                onChange={e => setUsername(e.target.value)}
            />
            <Input
                type="password"
                placeholder="رمز عبور خود را وارد کنید"
                onChange={e => setPassword(e.target.value)}
            />
            <Button
                className={`${hasError ? 'has-error' : ''}`}
                onClick={clickHandler}
                isLoading={isLoading}
            >
                وارد شوید
            </Button>
        </div>
    );
};

LoginForm.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(LoginForm)`
    > h2 {
        text-align: center;
        color: #fff;
        margin-bottom: 1.5em;
    }

    ${Input} {
        margin-bottom: 1em;
        text-align: center;
    }

    ${Button} {
        width: 100%;
        background: #fe5f55;
        color: #fff;
        margin-top: 0.625em;

        &.has-error {
            background: #13bdef;
        }
    }
`;
